import { environment } from '../../environments/environment';

export class AppUrls {
  // who delivers Angular
  public static readonly useTunnelForDevelopment = false; // true for NGROK else localhost

  // who delivers backend
  public static readonly useDemoForDevelopmentAPI = false; // true for Roesberg Online Demo
  public static readonly useTunnelForDevelopmentAPI = true; // true for NGROK else localhost
  public static baseUrlAngular = AppUrls.getBaseUrlAngular();
  public static actionSilentRefresh = 'silent-refresh.html';

  public static baseUrlMvc = AppUrls.getBaseUrlMvc();

  public static urlApi = 'api/';

  public static urlAuth = 'authorization/';
  public static actionAuthPswChange = 'ChangePassword';
  public static actionAuthLogin = 'Authorize';
  public static actionAuthLogout = 'Logout';
  public static actionAuthToken = 'Token';
  public static actionAuthUserInfo = 'UserInfo';
  public static actionAuthSessionCheck = 'CheckSession';

  public static urlConnect = 'connect/';
  public static actionConnectRevocation = 'revocation';

  public static urlWebDoku = 'webdoku';
  public static urlMessage = 'message';
  public static urlDocument = 'document';
  public static urlAnnotation = 'annotation';
  public static urlDocumentNavigation = 'documentnavigation';
  public static urlBasicNavigation = 'basicnavigation';
  public static urlCustomNavigation = 'customnavigation';
  public static urlSearch = 'search';
  public static urlSettings = 'settings';
  public static urlHistory = 'history';
  public static urlTempImages = 'images/temp/';
  private static urlLogout = 'logout';
  public static urlCloseWindow = 'home/closewindow';

  public static getBaseUrlAngular(): string {
    if (environment.production) {
      return window.location.origin + '/ldw/';
    }

    if (this.useTunnelForDevelopment) {
      return 'https://roesberg.livedok.ngrok.io/';
    } else {
      return 'https://localhost:4200/';
    }
  }

  public static getBaseUrlMvc(): string {
    if (environment.production) {
      return window.location.origin + '/';
    }
    if (this.useDemoForDevelopmentAPI) {
      return 'https://livedokdemo.roesberg.com/';
    }
    if (this.useTunnelForDevelopmentAPI) {
      return 'https://roesberg.livedok.ngrok.io/';
    } else {
      return 'https://localhost:44386/';
    }
  }

  public static getLogoutUrl(): string {
    return this.getBaseUrlMvc() + this.urlLogout;
  }

  public static getApiUrl(path: string, action: string | undefined = undefined): string {
    let result = this.baseUrlMvc + this.urlApi + path;
    if (action != undefined && action !== '') {
      result = result + '/' + action;
    }
    return result;
  }

  public static getAuthUrl(urlAction: string): string {
    return this.baseUrlMvc + this.urlAuth + urlAction;
  }

  public static getConnectUrl(urlAction: string): string {
    return this.baseUrlMvc + this.urlConnect + urlAction;
  }

  public static getImageUrl(image: string): string {
    return this.baseUrlMvc + this.urlTempImages + image;
  }

  public static getAssetsUrl(asset: string): string {
    return 'assets/' + asset;
  }

  public static domainMatchMvc(origin: string | undefined) {
    if (origin == undefined || origin === '') {
      return false;
    }
    const compare1 = origin.toLowerCase().replaceAll('/', '').replace('https:', '').replace('http:', '');

    const compare2 = this.baseUrlMvc.toLowerCase().replaceAll('/', '').replace('https:', '').replace('http:', '');
    return compare1 === compare2;
  }
}
